/**
 * CodeEdit parser: TextEdit's parse plus the gutter, folding, indent, guideline and
 * delimiter members this slice draws (`types.ts` documents each).
 */
import { parseOptionalBool, parseOptionalInt } from '../../../../parser/valueParsers';
import { slotInt } from '../../../../godot/variant/intSlots.js';
import { arrayBody, INT_ARRAY_FORMS, parsePackedStringArray } from './arrayForms.js';
import { parseTextEdit } from '../textedit/parser';
/** The three spellings an int-array slot accepts (`arrayForms.ts`), narrowed to the numbers `_draw_guidelines` indexes. */
function parseIntArray(value) {
    if (value === undefined)
        return undefined;
    const body = arrayBody(value, INT_ARRAY_FORMS);
    if (body === undefined)
        return undefined;
    return body
        .split(',')
        .map((element) => element.trim())
        .filter((element) => element.length > 0)
        .map((element) => slotInt(element) ?? 0);
}
/** The three spellings a String-array slot accepts (`arrayForms.ts`). An unreadable value reads as absent, the class default. */
function parseStringArray(value) {
    if (value === undefined)
        return undefined;
    return parsePackedStringArray(value) ?? undefined;
}
export function parseCodeEdit(heading, properties) {
    return {
        ...parseTextEdit(heading, properties),
        gutterDrawLineNumbers: parseOptionalBool(properties.gutters_draw_line_numbers),
        gutterZeroPadLineNumbers: parseOptionalBool(properties.gutters_zero_pad_line_numbers),
        gutterLineNumbersMinDigits: parseOptionalInt(properties.gutters_line_numbers_min_digits),
        gutterDrawBookmarks: parseOptionalBool(properties.gutters_draw_bookmarks),
        gutterDrawBreakpoints: parseOptionalBool(properties.gutters_draw_breakpoints_gutter),
        gutterDrawExecutingLines: parseOptionalBool(properties.gutters_draw_executing_lines),
        gutterDrawFoldGutter: parseOptionalBool(properties.gutters_draw_fold_gutter),
        lineFolding: parseOptionalBool(properties.line_folding),
        indentSize: parseOptionalInt(properties.indent_size),
        lineLengthGuidelines: parseIntArray(properties['line_length_guidelines']),
        delimiterComments: parseStringArray(properties['delimiter_comments']),
        delimiterStrings: parseStringArray(properties['delimiter_strings']),
    };
}
//# sourceMappingURL=parser.js.map